import { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Box, Grid } from '@mui/material';
import Question from './Question';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import { COMPLIANCE_INFO, ORIENTAL_ORANGE } from '../../../constants';
import { isBundle } from '../../commonCode';

function SubQuestion({
  question,
  answerHandler,
  itemsAnswer,
  disable,
  productData,
  isBundleCompliance = false,
}) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { productName, currentPage, theme } = leadGenerationContext;
  const classes = ProductUIStyles(theme);

  let trueValue = '';

  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);

  let jsxTooltip;
  const tooltipDesc = () => {
    if (question.name === 'AreEngaged') {
      jsxTooltip = (
        <>
          <span>{translation[question.questionDesc]}</span>
          {isBundleCompliance ? null : (
            <span
              id="areEngagedAriaTooltip"
              aria-label={t('Question Header Tooltip', {
                defaultValue: 'Do not select if not applicable for you',
              })}
              style={{ marginLeft: '10px' }}
            >
              <CustomTooltip
                text={t('Question Header Tooltip', {
                  defaultValue: 'Do not select if not applicable for you',
                })}
              />
            </span>
          )}
        </>
      );
    } else if (question.name === 'MontlyExpectedTransactions') {
      jsxTooltip = (
        <span id="subAriaDesc">
          <span className="MuiInputLabel-asterisk">* </span>
          {translation[question.questionDesc]}
        </span>
      );
    } else {
      jsxTooltip = <span id="subAriaDesc">{translation[question.questionDesc]}</span>;
    }
    return jsxTooltip;
  };

  return (
    <Grid
      container
      size={{ xs: 12 }}
      role="form"
      sx={isBundleCompliance || isBundle(productName) ? null : classes.subQuesPage}
      aria-roledescription={
        question.groupHeader
          ? translation[question.groupHeader]
          : translation[question.questionDesc]
      }
      aria-describedby={question.name === 'AreEngaged' ? 'areEngagedAriaTooltip' : 'subAriaDesc'}
    >
      {!(isBundle(productName) && currentPage === 'product-info') && (
        <>
          {question.groupHeader && (
            <Grid size={{ xs: 12 }} style={{ marginBottom: '22px' }}>
              <Box
                component="span"
                sx={classes.quesTitleStyle}
                aria-label={translation[question.groupHeader]}
              >
                {translation[question.groupHeader]}
              </Box>
            </Grid>
          )}
          <Grid size={{ xs: 12 }} style={{ marginBottom: isBundleCompliance ? '24px' : '30px' }}>
            <Box
              component="span"
              sx={
                isBundleCompliance
                  ? { ...classes.quesTitleBundleStyle, color: theme?.palette?.primary?.main }
                  : question.type !== 'Grouped'
                  ? classes.quesTitleStyle
                  : classes.quesTitleSubHeadingStyle
              }
            >
              {tooltipDesc()}
            </Box>
          </Grid>
        </>
      )}

      {question.subQuestions.map((element, index1) => (
        <Grid
          size={{ xs: 12 }}
          sx={
            isBundleCompliance
              ? classes.quesBundleSubtitleContainer
              : isBundle(productName) && currentPage !== COMPLIANCE_INFO
              ? {
                  margin: '5px 0',
                  paddingTop: isBundle(productName) ? 0 : '10px',
                  paddingLeft: '5px',
                  backgroundColor: theme?.palette?.fieldsBackground?.main,
                  border: `1px solid ${theme?.palette?.fieldsBorder?.main}`,
                  borderRadius: '24px',
                }
              : { margin: '2px 0 0 0' }
          }
          key={element}
        >
          {Object.keys(productData).length > 0 &&
            productData.questions.map((prodQuestion, index) => {
              trueValue = '';
              if (prodQuestion.name === element) {
                if (prodQuestion.name in itemsAnswer) {
                  trueValue = itemsAnswer[prodQuestion.name];
                }
                return (
                  <div
                    key={prodQuestion.name}
                    style={
                      isBundle(productName) && !isBundleCompliance ? { padding: '10px 15px' } : {}
                    }
                  >
                    <Question
                      parent={question.name}
                      question={prodQuestion}
                      subQuestion
                      disable={disable}
                      answerHandler={answerHandler}
                      itemsAnswer={itemsAnswer}
                      isBundleCompliance={isBundleCompliance}
                    />
                  </div>
                );
              }
              return null;
            })}
        </Grid>
      ))}
      {question.groupFooter && !isBundle(productName) && (
        <Grid size={{ xs: 12 }} style={{ margin: '20px 0 10px 0', border: '2px solid red' }}>
          <span
            style={{ fontWeight: 'bold', color: ORIENTAL_ORANGE, fontSize: '13px' }}
            aria-label={translation[question.groupFooter]}
          >
            * {translation[question.groupFooter]}
          </span>
        </Grid>
      )}
    </Grid>
  );
}

SubQuestion.propTypes = {
  question: PropTypes.object,
  answerHandler: PropTypes.func,
  itemsAnswer: PropTypes.object,
  disable: PropTypes.bool,
  productData: PropTypes.object,
  isBundleCompliance: PropTypes.bool,
};

export default SubQuestion;
